export default "__VITE_ASSET__g2_ce$03__"